import ExpandableGroup from '@root/joinroot.com/src/components/sections/expandable/expandable-group';
import ExpandableItem from '@root/joinroot.com/src/components/sections/expandable/expandable-item';
import ExpandableSection from '@root/joinroot.com/src/components/sections/expandable/expandable-section';
import Market from '@root/core/src/models/market';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { H2, H4, P1 } from '@root/joinroot.com/src/components/text';

export default function CovidDrivingExpandables({ dataToDisplay }) {
  const states = dataToDisplay.states ? Object.keys(dataToDisplay.states).sort() : [];
  const hasStateData = states.length > 0;

  if (!hasStateData) { return null; }
  return (
    <ExpandableSection>
      <H2 css={styles.headline}>Driving trends by metro area</H2>
      <ExpandableGroup>
        {states.map((stateId, i) => {
          const overallPctChange = dataToDisplay.states[stateId]['2020'].pctChange;
          const hasMetroData = dataToDisplay.states[stateId].metroAreas && Object.keys(dataToDisplay.states[stateId].metroAreas).length;
          if (hasMetroData) {
            return (
              <ExpandableItem
                itemTitle={Market.MAPPING[stateId]}
                itemTitleSecondary={`${overallPctChange}%`}
                key={i}
              >
                {Object.keys(dataToDisplay.states[stateId].metroAreas).map((metroArea, j) => (
                  <div
                    css={styles.contentContainer}
                    key={j}
                  >
                    <P1 css={styles.metroTitle}>{metroArea.toLowerCase().replace(/-/gi, ' - ')}:</P1>
                    <P1>{dataToDisplay.states[stateId].metroAreas[metroArea]['2020'].pctChange}%</P1>
                  </div>
                ))}
              </ExpandableItem>
            );
          }
          return (
            <div
              css={styles.noMetroData}
              key={i}
            >
              <H4>{stateId}</H4>
              <H4>{overallPctChange}%</H4>
            </div>
          );
        })}
      </ExpandableGroup>
    </ExpandableSection >
  );
}

CovidDrivingExpandables.propTypes = {
  dataToDisplay: PropTypes.any,
  endDate: PropTypes.instanceOf(Date),
  metric: PropTypes.string,
  metricUnits: PropTypes.string,
  startDate: PropTypes.instanceOf(Date),
};

const styles = StyleSheet.create({
  headline: {
    marginBottom: 30,
    textAlign: 'center',
    ...Responsive.md({
      marginBottom: 70,
    }),
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 72,
    marginTop: 10,
    '&:first-of-type': {
      marginTop: 0,
    },
    'p': {
      color: Colors.nearBlack(),
    },
  },
  metroTitle: {
    textTransform: 'capitalize',
  },
  noMetroData: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 82px 20px 10px',
    borderBottom: `1px solid ${Colors.gray30()}`,
  },
});
